var _circle, _path, _path2, _circle2, _circle3, _circle4, _path3, _rect, _rect2, _path4, _path5, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#E1EFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12 13.3954 12.8954 12.5 14 12.5H32C33.1046 12.5 34 13.3954 34 14.5V28C34 29.1046 33.1046 30 32 30H14C12.8954 30 12 29.1046 12 28V14.5Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12 13.3954 12.8954 12.5 14 12.5H32C33.1046 12.5 34 13.3954 34 14.5V17H12V14.5Z",
    fill: "#8BB7F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9,
    cy: 14.75,
    r: 0.8,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 14.75,
    r: 0.8,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1,
    cy: 14.75,
    r: 0.8,
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.5H14C12.8954 12.5 12 13.3954 12 14.5V28C12 29.1046 12.8954 30 14 30H32C33.1046 30 34 29.1046 34 28V14.5C34 13.3954 33.1046 12.5 32 12.5ZM32 13.6C32.4971 13.6 32.9 14.0029 32.9 14.5V28C32.9 28.4971 32.4971 28.9 32 28.9H14C13.5029 28.9 13.1 28.4971 13.1 28V14.5C13.1 14.0029 13.5029 13.6 14 13.6H32Z",
    fill: "#4E7AB5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19.4,
    width: 10.5,
    height: 1.5,
    rx: 0.75,
    fill: "#B0C1D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22.4,
    width: 7.5,
    height: 1.5,
    rx: 0.75,
    fill: "#B0C1D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24.5C23.5 23.3954 24.3954 22.5 25.5 22.5H33C34.1046 22.5 35 23.3954 35 24.5V29C35 30.1046 34.1046 31 33 31H32.4V33.4C32.4 33.7314 32.0136 33.9137 31.7567 33.7043L28.44 31H25.5C24.3954 31 23.5 30.1046 23.5 29V24.5Z",
    fill: "#BAE0BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22.5H25.5C24.3954 22.5 23.5 23.3954 23.5 24.5V29C23.5 30.1046 24.3954 31 25.5 31H28.44L31.7567 33.7043C32.0136 33.9137 32.4 33.7314 32.4 33.4V31H33C34.1046 31 35 30.1046 35 29V24.5C35 23.3954 34.1046 22.5 33 22.5ZM33 23.6C33.4971 23.6 33.9 24.0029 33.9 24.5V29C33.9 29.4971 33.4971 29.9 33 29.9H31.3V32.05L28.83 29.9H25.5C25.0029 29.9 24.6 29.4971 24.6 29V24.5C24.6 24.0029 25.0029 23.6 25.5 23.6H33Z",
    fill: "#5E9C76"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9,
    cy: 26.75,
    r: 0.95,
    fill: "#5E9C76"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.25,
    cy: 26.75,
    r: 0.95,
    fill: "#5E9C76"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.6,
    cy: 26.75,
    r: 0.95,
    fill: "#5E9C76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebChat);
export default __webpack_public_path__ + "static/media/web_chat.b5c48644.svg";
export { ForwardRef as ReactComponent };